import {
  PROSPECT_ACTION_FILTER_ALL,
  ProspectActionFilter,
  ProspectActionFilterMode,
} from "@/app/types/prospect/ProspectActionFilter";
import { ProspectListTab } from "@/app/types/prospect/ProspectListTab";
import { UCookie } from "@/app/utils/UCookie";
import { CookieKey, WORKSPACE_COOKIE_MAX_AGE } from "@/app/vars/Storage";

export class UProspectFilter {
  public static parseTab(raw?: string | null): ProspectListTab {
    return raw && Object.values(ProspectListTab).includes(raw as ProspectListTab)
      ? (raw as ProspectListTab)
      : ProspectListTab.ALL;
  }

  public static parseActionFilter(raw?: string | null): ProspectActionFilter {
    if (!raw) {
      return PROSPECT_ACTION_FILTER_ALL;
    }

    try {
      const parsed = JSON.parse(raw) as ProspectActionFilter;

      if (!parsed || !Object.values(ProspectActionFilterMode).includes(parsed.mode)) {
        return PROSPECT_ACTION_FILTER_ALL;
      }

      return { mode: parsed.mode, kind: parsed.kind, typeId: parsed.typeId };
    } catch (_error) {
      return PROSPECT_ACTION_FILTER_ALL;
    }
  }

  public static readStoredTab(): ProspectListTab {
    return UProspectFilter.parseTab(UCookie.read(CookieKey.PROSPECT_LIST_TAB));
  }

  public static readStoredActionFilter(): ProspectActionFilter {
    return UProspectFilter.parseActionFilter(UCookie.read(CookieKey.PROSPECT_LIST_ACTION_FILTER));
  }

  public static storeTab(tab: ProspectListTab): void {
    UCookie.write(CookieKey.PROSPECT_LIST_TAB, tab, WORKSPACE_COOKIE_MAX_AGE);
  }

  public static storeActionFilter(filter: ProspectActionFilter): void {
    UCookie.write(
      CookieKey.PROSPECT_LIST_ACTION_FILTER,
      JSON.stringify(filter),
      WORKSPACE_COOKIE_MAX_AGE,
    );
  }
}
